import React from "react";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import NavDrawerList from "./NavDrawerList";
import NavDrawerHeader from "./NavDrawerHeader";
import { navDataPrimary } from "./data";
import { Button, makeStyles } from "@material-ui/core";

const drawerWidth = 300;

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    
  },
  drawerPaper: {
    width: drawerWidth,
   
  },
}));

const NavDrawer = ({open ,handleClick, siteTitle }) => {
    
  const classes = useStyles();
  
  return (
    <div>
      <Drawer
        className={classes.drawer}
        variant="temporary"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper,
        }}
        onClose={handleClick}
      >
        <NavDrawerHeader handleClick={handleClick} siteTitle={siteTitle}  />
        <Divider />
        <NavDrawerList data={navDataPrimary} />
        <Divider />
        
        <Button variant="contained"
        style={{
          backgroundColor: "#2196f3",
								color: "white",
								textTransform: "initial",
                margin:'8px'
							
        }}>
          Get Started
        </Button>
      </Drawer>
    </div>
  );
}

export default NavDrawer